import { apiClient } from 'pobble-components/dist/api'

const apiGetSchool = (id, params) =>
  apiClient.get(`/v3/schools/${id}`, { params })

export { apiGetSchool }
